<template>

    <Modal ref="modal" title="Something went wrong" size="large">

        <p class="mb-4">We're sorry, something went wrong</p>

        <div v-if="errors?.errors" v-for="(errorLines, param) in errors.errors" class="w-full bg-sn-dark-red text-white rounded-xl p-3">
            <ul class="list-disc">
                <li class="ml-6" v-for="line in errorLines" v-text="line"></li>
            </ul>
        </div>

        <div class="gap-4 mt-6 grid grid-cols-2">
            <Button type="secondary" size="large" @click="close">Okay</Button>
            <Button v-if="errors?.retryMethod" type="primary" size="large" @click="close(); errors.retryMethod">Try Again</Button>
<!--            <Button type="primary" size="large" @click="confirm">Try Again</Button>-->
        </div>
    </Modal>

</template>
<script setup lang="ts">

import Button from "@/components/core/Button.vue";
import Modal from '@/components/core/modals/Modal.vue';
import {useErrorModal} from "@/composables/useErrorModal";

const modal = ref<InstanceType<typeof Modal>|null>(null);
const { errors } = useErrorModal();

watch(errors, () => {
    if(errors.value?.errors && Object.keys(errors.value.errors).length > 0) {
        modal.value?.open();
    }
}, {deep: true})

function open(event?: Event) {
    modal.value?.open();
}

function close(event?: Event) {
    modal.value?.close();
}

defineExpose({open, close});
</script>